import get from 'lodash/get';
import uniq from 'lodash/uniq';
import { COUPON_QUERY_PARAM } from '../../constants/queryParams';
import { getProductsBySkus } from '../../actions/products';
import { fetchActiveCouponIfNeeded } from '../../actions/subscription';
import {
  getSkuFromQuery,
  getDefaultSkus,
} from '../subscription/findProductHelpers';

export default function fetchProducts(location, isRenew = false) {
  return (dispatch, getState) => {
    const fromQuery = getSkuFromQuery(location);
    const config = get(getState(), 'config.autoupdate');
    const defaultSkus = getDefaultSkus(location, config, isRenew);
    const allSkus = uniq(defaultSkus.concat(fromQuery));
    const couponCode = get(location, ['query', COUPON_QUERY_PARAM]);
    const meta = { isRenew, defaultSkus, fromQuery };
    if (couponCode) {
      return dispatch(fetchActiveCouponIfNeeded(couponCode)).then(() =>
        dispatch(getProductsBySkus(allSkus, meta)),
      );
    }
    return dispatch(getProductsBySkus(allSkus, meta));
  };
}
